import { Delete, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import BrandMasterContext from "../../../../context/BrandMasterContext/BrandMasterContext";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import {
  Delete_Brand_Master,
  Enable_Disable_Brand_Master,
  Get_Details_Brand_Master,
} from "../../../../Apis/brandMasterApi/BrandMasterApi";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";

const BrandMasterDataTabelContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setdialogs,
    setId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(BrandMasterContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get brand master Details
   */
  const { mutate: userDetails, isLoading: isLoadingUserDetails } = useMutation(
    (brandId) => Get_Details_Brand_Master(brandId, setFormData, setdialogs)
  );

  const GetUserDetails = (brandId) => {
    userDetails(brandId);
    setId(brandId);
    setIsEdit(false);
  };

  /**
   * delete brand master
   */
  const { mutate: brandMasterDelete, isLoading: isLoadingDelete } = useMutation(
    (brandId) => Delete_Brand_Master(brandId, refetch)
  );

  const DeleteBrandMaster = async (brandId) => {
    let { isConfirmed } = await SweetConfirmation();
    if (isConfirmed) {
      brandMasterDelete(brandId);
    }
  };

  /**
   * enable / disable brand master
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    Enable_Disable_Brand_Master(formData, refetch)
  );

  const handleBrandMasterStatusChange = (brandId, status) => {
    let formDate = {
      brandId: brandId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.brandId === brandId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 180,
      field: "logo",
      headerName: "Image",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <input
          type="image"
          img="true"
          src={
            params.row.logo
              ? params.row.logo
              : require("../../../../assets/Images/ImageNotFound.png")
          }
          alt="photo"
          style={{ height: "2rem" }}
        />
      ),
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "brandName",
      headerName: "Brand Name",
      renderCell: (params) =>
        params.row.brandName ? params.row.brandName : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "brandDesc",
      headerName: "Brand Desc",
      renderCell: (params) =>
        params.row.brandDesc ? params.row.brandDesc : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "slugUrl",
      headerName: "Slug",
      renderCell: (params) => (params.row.slugUrl ? params.row.slugUrl : "--"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleBrandMasterStatusChange(
                params.row.brandId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Edit">
              <IconButton
                aria-label="edit"
                onClick={() => GetUserDetails(params.row.brandId)}
              >
                <Edit style={{ color: "#7366ff" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() => DeleteBrandMaster(params.row.brandId)}
              >
                <Delete style={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse isLoading={isLoadingUserDetails || isLoadingDelete} />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.brandId}
        addButton={true}
      />
    </Fragment>
  );
};

export default BrandMasterDataTabelContainer;
